import { RefreshCw } from "lucide-react";
import { useServiceWorkerUpdate } from "../hooks/useServiceWorkerUpdate";

export function AppUpdateBanner() {
  const { visible, apply } = useServiceWorkerUpdate();
  if (!visible) return null;

  return (
    <div className="app-update-banner" role="status">
      <RefreshCw aria-hidden="true" />
      <span>A new version of CHEW is ready.</span>
      <button className="app-update-reload" onClick={apply} type="button">Reload</button>
    </div>
  );
}
